module.exports = __webpack_public_path__ + "static/media/viruspolicy.508e8383.png";